<script>
import Layout from '@layout/main'

export default {
  page() {
    return {
      title: `隱私權與服務條款`,
    }
  },
  components: {
    Layout,
  },
  data() {
    return {}
  },
}
</script>
<template>
  <Layout>
    <div :class="$style.privacy">
      <BaseBanner title="隱私權與服務條款" :image="require('@assets/images/service/index_banner.png')" class="isHasNoFilter" custom-class="isStyleWhite" />
      <section class="container--small section ">
        <el-collapse accordion class="privacy__list isStyleBase">
          <el-collapse-item title="一、認知與接受條款">
            <ul style="list-style-type:decimal;">
              <li>
                零壹科技股份有限公司（以下簡稱零壹科技─或本公司）係依據本服務條款提供「零壹科技 網站（ http://www.zerone.com.tw ）」 （簡稱：零壹網站）網站產品資訊、課程、
                設計、製造、販賣及銷售(以下簡稱「本服務」)。 當會員完成零壹網站之會員註冊手續、 開始使用本服務時，即表示已完全閱讀、瞭解並同意接受本服務條款及「隱私權保護政 策」之全部內容。
              </li>
              <li>
                零壹網站可隨時修訂本條款及「隱私權保護政策」，並將修訂或變更的內容公佈在零壹網站 的網站上，公佈之日起七日後， 該修訂或變更的內容即刻生效，本網站將不會個別通知會員，
                建議會員隨時注意該等修改或變更。
              </li>
              <li>
                會員於任何修改或變更後繼續使用本服務時，視為會員已閱讀、瞭解並同意接受該等修改 或變更。若不同意上述的修訂或變更 ，或不接受本服務條款的其他任一約定，會員應立即停 止使用本服務。
              </li>
              <li>
                會員同意使用本服務之意思表示等，皆以電子文件為表示方式。
              </li>
            </ul>
          </el-collapse-item>
          <el-collapse-item title="二、會員的註冊義務">
            <p>為了能使用本服務，您同意以下事項：</p>
            <ul style="list-style-type:decimal;">
              <li>
                依本服務註冊表之提示提供您本人正確、最新及完整的個人資料。
              </li>
              <li>
                加入會員時，若有資料不實或資料錯誤等問題，由登錄者自行負責。
              </li>
              <li>
                登錄不實的資料被發現時，網站管理者有權利直接停止服務或取消服務契約，本網站或第三者所受到的損失，由涉此事件的會員來承擔負責。
              </li>
              <li>
                用假名或他人的身份訊息加入會員者，無法得到法律上的保護且必須為此擔負民法和刑法上所有的責任。
              </li>
            </ul>
          </el-collapse-item>
          <el-collapse-item title="三、零壹網站隱私權政策">
            <p>
              關於您的會員註冊以及其他特定資料依零壹網站「隱私權保護政策」受到保護與規範。您了解當您使用本服務時，您同意本網站依據「隱私權保護政策」進行您個人資料的蒐集、處理與利用，包括跨國(境)間的國際傳輸與儲存及本網站及零壹科技關係企業之利用。<br />
              個人資料之蒐集、處理及利用
            </p>
            <ul style="list-style-type:decimal;">
              <li>
                告知事項：茲依個人資料保護法(以下稱「個資法」)第8條第1項規定，告知本網站會員下列事項：
                <ul style="list-style-type:decimal-leading-zero;">
                  <li>蒐集機關名稱：零壹科技股份有限公司。</li>
                  <li>
                    蒐集之目的：040行銷、069契約、類似契約或其他法律關係事務、090消費者、客戶管理與服務、091消費者保護、148網路購物及其他電子商務服務、157調查、統計與研究分析、181其他經營合於營業登記項目或組織章程所定之業務。
                  </li>
                  <li>個人資料之類別：姓名、姓別、服務單位、職稱、連絡方式(電話、Email、地址)及其他足資識別之個人資料(識別類)。</li>
                  <li>個人資料利用之期間：會員身分存續期間。</li>
                  <li>個人資料利用之地區：零壹科技及集團企業為達前述蒐集目的之營運所及地區、提供利 用之對象的業務所及地區(含未受主管機關禁止國際傳輸的中華民國境外)。</li>
                  <li
                    >個人資料利用之對象及方式：
                    <ul style="list-style-type:upper-alpha;">
                      <li>零壹科技將以電子郵件、電話、簡訊或書面的方式向會員提供最新的產品資訊、優惠活動或課程訊息。且會將會員資料交予物流業者、金流公司或金融機構、運送廠商等以完成本服務。</li>
                      <li
                        >零壹科技會將會員於零壹網站登錄或提供之個人資料提供予旗下「i-Partner零壹經銷夥伴網http://ipartner.zerone.com.tw」等各網站蒐集、處理、國際傳輸及 為以下之利用：
                        <ul style="list-style-type:lower-alpha;">
                          <li>作為接受各網站各項服務與資訊之用，包括但不限於市場調查、問卷或本公司受企業委託代為發送之各類電子報等資訊。</li>
                          <li>其他另經會員本人以書面、電子郵件、傳真、網頁點選按鈕同意之特定目的之利用。</li>
                        </ul>
                      </li>
                      <li>
                        零壹科技將基於共同行銷之目的，在適當且必要的範圍內將會員資料予以揭露、轉介或交換予本公司所屬其他網站及友站、關係企業及業務合作夥伴交互運用，但前開資料應妥善運用及管理，且本公司所屬其他網站及友站、關係企業及業務合作夥伴會確保會員所提供之所有資料皆受到「隱私權保護政策」之嚴格保護。
                      </li>
                    </ul>
                  </li>
                  <li
                    >當事人依個資法第三條規定得行使之權利及方式：會員得透過本網站提供之交易平台，
                    進行查詢、閱覽、下載複製本、補充或更正個人資料；有關請求停止蒐集、處理、利用或刪除個人資料部分，會員得於週一至週五透過marketing@zerone.com.tw客服信箱，或至本網站留言。
                  </li>
                </ul>
              </li>
            </ul>
          </el-collapse-item>
          <el-collapse-item title="四、帳號、密碼及安全">
            <ul style="list-style-type:decimal;">
              <li>
                會員帳號或密碼資料不能揭露、轉讓、贈與、出租或借貸予他人。
              </li>
              <li>
                無正當理由，非經本網站之書面同意，會員不能與他人共用帳號。
              </li>
              <li>
                會員自身的帳號被偷竊或遭第三者盜用時，應立即通報零壹網站，依照零壹網站所指示的步驟處理。
              </li>
              <li>
                會員對自身的帳號和密碼因管理不善或不當的疏失，致所發生的一切損失應自行負責。
              </li>
            </ul>
          </el-collapse-item>
          <el-collapse-item title="五、使用者的守法義務及承諾">
            <p>
              會員承諾絕不為任何非法目的或以任何非法方式使用本服務，並承諾遵守中華民國相關法規及一切使用網際網路之國際慣例。會員若係中華民國以外之使用者亦同。會員同意並保證不得利用本服務從事侵害他人權益或違法之行為，包括但不限於：</p
            >
            <ul class="ml--4" style="list-style-type:decimal;">
              <li>
                公布或傳送任何誹謗、侮辱、具威脅性、攻擊性、不雅、猥褻、不實、違反公共秩序或善良風俗或其他不法之文字、圖片或任何形式的檔案。
              </li>
              <li>
                侵害或毀損他人名譽、隱私權、營業秘密、商標權、著作權、專利權、其他智慧財產權及其他權利；
              </li>
              <li>
                違反依法律或契約所應負之保密義務；
              </li>
              <li>
                冒用他人名義或使用虛假電子郵件使用本服務；
              </li>
              <li>
                傳輸或散佈電腦病毒；
              </li>
              <li>
                從事未經本網站事前授權的商業行為；
              </li>
              <li>
                刊載、傳輸、發送垃圾郵件、連鎖信，違法或未經本網站許可之多層次傳銷訊息及廣告等；儲存任何侵害他人智慧財產權或違反法令之資料；
              </li>
              <li>
                對本服務其他用戶或第三人產生困擾、不悅或違反一般網路禮節致生反感之行為；
              </li>
              <li>
                未經本網站事前書面同意，不得下載、公開傳輸、轉載、重製、修改、販賣、轉賣、商業 利用本網站及其內容，亦不得蒐集或利用本網站刊載之商品目錄、描述、價格等資料，或利
                用該等資料收集、robots、收集相似數據及調取工具的行為。
              </li>
              <li>
                其他不符本服務所提供的使用目的之行為或本網站有正當理由認為不適當之行為。
              </li>
            </ul>
          </el-collapse-item>
          <el-collapse-item title="六、服務終止">
            <ul style="list-style-type:decimal;">
              <li>
                零壹網站為了維持良好服務，將盡可能維護保持系統良好之運行，在設備發生障礙或故障時，本網站會儘快修理恢復其運作。
              </li>
              <li>
                當有以下有關狀況發生，零壹網站將停止服務：
                <ul style="list-style-type:upper-alpha;">
                  <li>為了進行補修工作及系統正常維護，不得不停止服務時。</li>
                  <li>天災、事變等不可抗力事件或通訊業者必須停止電子通訊服務的狀況時。</li>
                </ul>
              </li>
            </ul>
          </el-collapse-item>
          <el-collapse-item title="七、商品價格及價格變化">
            <ul style="list-style-type:decimal;">
              <li>
                產品的價格將在本網站官方網站上標示。這類資訊可能隨時更改且不發出任何通知。商品運送費用依運送地、商品種類、用戶選擇送貨方式的不同而異。
              </li>
              <li>
                若本網站商品發生錯誤定價時，將採取下列措施之一：
                <ul style="list-style-type:upper-alpha;">
                  <li>若商品的正確定價低於本網站的錯誤定價，則按照較低的定價向用戶銷售交付商品。</li>
                  <li>若商品的正確定價高於本網站的錯誤定價，本網站會根據情況決定，在交付商品前與 用戶確認是否依正確定價購買商品，或者取消訂單。</li>
                </ul>
              </li>
            </ul>
          </el-collapse-item>
          <el-collapse-item title="八、智慧財產的保護">
            <ul style="list-style-type:decimal;">
              <p>
                本網站所使用之軟體、圖片或程式，網站上所有內容包括但不限於圖像、產品設計、著作、 圖片、檔案、資訊、資料、網站畫面的安排、網頁設計均由本網站或其他權利人依法擁有其
                智慧財產權，包括但不限於商標權、專利權、著作權、營業秘密與專有技術等。任何人未經 本網站及權利人授權，不得以任何方式擅自使用、展示、修改、重製，公開播送、公開傳輸
                、轉載、改作、散佈、發行、公開發表，進行還原工程解編或反向組譯。如有違反，除依著 作權法及相關法律規定論處，並應對零壹網站負損害賠償責任 (包括但不限於訴訟費用及律 師費用等 ) 。
              </p>
            </ul>
          </el-collapse-item>
          <el-collapse-item title="九、準據法與管轄法院">
            <p>本服務條款之解釋與適用，以及與本服務條款有關的爭議，將依照中華民國法律規定， 並以臺灣臺北地方法院為第一審管轄法院。</p>
          </el-collapse-item>
          <el-collapse-item title="十、資通安全保護政策">
            <ul style="list-style-type:decimal;">
              <li>
                目的：
                <p
                  >為確保零壹科技股份有限公司(以下簡稱「本公司」)所屬之資訊資產的機密性、完整性及可用性，依資通安全要求，符合「公開發行公司建立內部控制制度處理準則」第九條使用電腦化資通系統處理者相關控制作業及相關法令、法規之要求，使其免於遭受內、外部蓄意或意外之威脅，特訂定本政策。</p
                >
              </li>
              <li>
                適用範圍：
                <ul style="list-style-type:decimal-leading-zero;">
                  <li>本政策適用範圍為本公司之全體同仁、委外服務廠商、資料使用者(含保管者)與訪客等相關之系統。</li>
                  <li>資通安全管理範疇所涵蓋領域，避免因人為疏失、蓄意或天然災害等因素，導致資料不當使用、洩漏、竄改、破壞等情事發生，對本公司造成各種可能之風險。</li>
                </ul>
              </li>
              <li>
                目標：
                <p>本公司資通安全政策為「有效運用資源，確保資訊資產之機密性、完整性與可用性」。期藉本政策之實施，達成下列目標：</p>
                <ul style="list-style-type:decimal-leading-zero;">
                  <li>建立安全及可信賴之資訊化作業環境，確保本公司資料、系統、設備及網路之安全，以保障本公司業務永續運作。</li>
                  <li>保護本公司業務服務之安全，確保資訊需經授權人員才可存取資訊，以維護其機密性。</li>
                  <li>保護本公司業務服務之安全，避免未經授權的修改，以確保其正確性與完整性。</li>
                  <li>建立本公司業務永續運作計畫，以確保本公司資通業務服務之持續運作。</li>
                  <li>確保本公司各項業務服務之執行，須符合資通安全規範及合作方之契約要求。</li>
                </ul>
              </li>
              <li>
                責任：
                <ul style="list-style-type:decimal-leading-zero;">
                  <li>本公司應成立「資通安全」組織，統籌相關安全事項推動。</li>
                  <li>管理階層應積極參與及支持「資通安全」管理制度，並透過適當的標準和程序，落實執行本政策。</li>
                  <li>本公司全體同仁、委外服務廠商、資料使用者(含保管者)與訪客等皆應遵守本政策。</li>
                  <li>本公司全體同仁、委外服務廠商及資料使用者(含保管者)均有責任透過適當通報機制，通報資通安全事件或弱點。</li>
                  <li>任何危及資通安全之行為，將視情節輕重追究其民事、刑事責任，或依本公司之相關規定進行議處。</li>
                </ul>
              </li>
              <li>
                管理指標：
                <p>為確保組織資通安全管理目標與績效之達成，並符合資通安全政策目標之一致性，落實資通安全管理制度之實施，訂定「資通安全保護目標達成計畫(I-B-01-04)」。</p>
              </li>
              <li
                >管理審查：
                <p
                  >本政策應每年至少進行1次管理審查，以反映政府法令、技術及業務等最新發展情況，確保本公司業務永續運作之能力。資通安全組織、主管機關(或法令、法規要求)或專家學者等利害關係人如有資通安全相關回饋事項，應列入管理審查會議之討論議題。</p
                >
              </li>
              <li
                >實施：
                <p>本政策經資通安全管理組織研擬核定後實施，修訂時亦同。</p>
              </li>
            </ul>
          </el-collapse-item>
        </el-collapse>
      </section>
    </div>
  </Layout>
</template>
<style lang="scss" module>
.privacy {
  :global {
    .privacy {
      &__list {
        .el-collapse-item {
          &__header {
            padding-top: 25px;
            padding-bottom: 25px;
            font-size: 1.5rem;

            @include max-md {
              font-size: 1.2rem;
            }
          }

          &__content {
            padding-top: 1.5rem;
            padding-bottom: 1.5rem;
            font-size: 1rem;
            @include max-md {
              font-size: 0.875rem;
            }
            p {
              margin-bottom: 10px;
            }

            ul {
              margin-left: -1em;

              &.ml--4 {
                margin-left: -4px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
